__turbopack_context__.v({
  "Cont": "FeatureImage-module-sass-module__V3j4fq__Cont",
  "FeatureImage": "FeatureImage-module-sass-module__V3j4fq__FeatureImage",
});
